import React, { useCallback, useEffect, useRef, useState } from "react";
import { Nav } from "../../layouts/navbar/nav";
import ENsponsore from "../../assets/images/Sponsoring-04.webp";
import FRsponsore from "../../assets/images/Sponsoring-03.png";
import field from "../../assets/images/2025-Program/golf-ball-flag.jpg";
import { useTranslation } from "react-i18next";
import Header from "../../layouts/header";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import axios from "axios";
import { useSelector } from "react-redux";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";
import { partenaireData } from "../../json/partenairesData";
import images from "../../constant/images";

export default function Sponsoring() {
  const { i18n, t } = useTranslation();
  const language = localStorage.getItem("i18nextLng");
  const baseUrl = useSelector((state) => state.gtm.baseUrl);
  const [discounts, setDiscounts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const fetchDiscounts = useCallback(async () => {
    try {
      const response = await axios.get(`${baseUrl}/discounts`);
      setDiscounts(response.data.discounts || []);
    } catch (error) {
      console.error("Failed to fetch discounts:", error);
    } finally {
      setIsLoading(false);
    }
  }, [baseUrl]);

  useEffect(() => {
    fetchDiscounts();
  }, [fetchDiscounts]);

  const prevRef = useRef();
  const nextRef = useRef();
  const [swiperInstance, setSwiperInstance] = useState();



  useEffect(() => {
    if (swiperInstance && prevRef.current && nextRef.current) {
      swiperInstance.params.navigation.prevEl = prevRef.current;
      swiperInstance.params.navigation.nextEl = nextRef.current;
      swiperInstance.navigation.init();
      swiperInstance.navigation.update();
    }
  }, [swiperInstance]);



  return (
    <div className="mb-8">
      <Header
        image={field}
        title={t("sponsoring_content.sponsoring")}
      />

      {/* Content Section */}
      <div className="space-y-10">
        <div className="flex flex-col gap-4 items-center relative justify-center">
          <div
            className="flex flex-col gap-4 px-4 md:px-[10rem] relative text-[#5a5a5a] text-base md:text-[20px] karla-font leading-relaxed tracking-wide"
            style={{ wordSpacing: "0.2rem" }}
          >
            <div className="flex flex-col gap-4 items-center relative justify-center">
              <div className="space-y-2">
                <p className="mb-7">{t("sponsoring_content.mission")}</p>
                <p className="font-bold ">{t("sponsoring_content.title")}</p>
                <ul className="space-y-2 list-disc list-outside">
                  {t("sponsoring_content.benefits", {
                    returnObjects: true,
                  }).map((benefit, index) => (
                    <li key={index}>
                      <strong>{benefit.title}</strong>
                      <span className="ms-3">{benefit.description}</span>
                    </li>
                  ))}
                </ul>
                <h2 className="font-bold pt-7">{t("sponsoring_content.sponsorships.title")}</h2>
                {t("sponsoring_content.sponsorships.plans", {
                  returnObjects: true,
                }).map((plan, index) => (
                  <p key={index}>
                    <b>{plan.name}:</b> {plan.details}
                  </p>
                ))}
                <em>{t("sponsoring_content.sponsorships.note")}</em>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center  flex flex-col gap-6 md:gap-[3rem] text-xl md:text-3xl font-semibold px-4 py-4">
          <h1
            id="Partenaires"
            className="text-2xl sm:text-3xl lg:text-4xl text-center part custom-font"
          >
            {/* {t("aboutUs_content.partners")} */}
            Sponsors
          </h1>
          <div className="relative">
            <Swiper
              spaceBetween={15}
              loop={true}
              breakpoints={{
                // Mobile first (smallest screens)
                0: {
                  slidesPerView: 2,
                  spaceBetween: 10,
                },
                // Small tablets
                480: {
                  slidesPerView: 3,
                  spaceBetween: 15,
                },
                // Larger phones/tablets
                640: {
                  slidesPerView: 4,
                  spaceBetween: 20,
                },
                // Your custom breakpoint
                790: {
                  slidesPerView: 4,
                  spaceBetween: 25,
                },
                // Small desktops
                1024: {
                  slidesPerView: 5,
                  spaceBetween: 30,
                },
                // Large desktops
                1280: {
                  slidesPerView: 6,
                  spaceBetween: 40,
                },
              }}
              modules={[Navigation, Pagination, Autoplay]}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              onSwiper={setSwiperInstance}
              className="w-full md:w-[75rem] "
            >
              {partenaireData?.map((item) => (
                <SwiperSlide key={item.id} className="p-2 md:p-4 ">
                  <div className="relative flex justify-center items-center shadow-[0px_3px_15px_rgba(0,0,0,0.2)] rounded-full bg-white p-3 md:p-4 lg:h-[150px] lg:w-[150px] w-[100px] h-[100px]  md:h-[100px] md:w-[100px] mx-auto">
                    <img
                      src={item.image}
                      alt="Partner Logo"
                      className="h-full w-[95%] object-contain"
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
}
